import axios from "../config/axiosConfig";

export const createWalletTransaction = async (data) => {
  try {
    const response = await axios.post("/walletTransactions", data);
    return response?.status;
  } catch (error) {
    console.error("Error in createWalletTransaction:", error);
    throw error;
  }
};

export const createDepositEntry = async (data) => {
  try {
    const response = await axios.post("/walletTransactions/deposit-entry", data);
    return response;
  } catch (error) {
    console.error("Error in createDepositEntry:", error);
    throw error;
  }
};

export const createWithdrawRequest = async (data) => {
  try {
    const response = await axios.post("/walletTransactions/withdraw-request", data);
    return response?.status;
  } catch (error) {
    console.error("Error in createWithdrawRequest:", error);
    throw error;
  }
};

export const getWalletTransactions = async ({
  page = 1,
  limit = 10,
  type = "",
  status = "",
}) => {
  try {
    const response = await axios.get("/walletTransactions", {
      params: { page, limit, type, status },
    });
    return response;
  } catch (error) {
    console.error("Error fetching wallet transactions:", error);
    throw error;
  }
};

export const getAdminPendingWithdrawRequests = async ({
  page = 1,
  limit = 10,
}) => {
  try {
    const response = await axios.get("/walletTransactions/admin/pending-withdrawals", {
      params: { page, limit },
    });
    return response;
  } catch (error) {
    console.error("Error fetching pending withdrawal requests:", error);
    throw error;
  }
};

export const getAdminWithdrawRequests = async ({
  page = 1,
  limit = 10,
  status = "",
}) => {
  try {
    const response = await axios.get("/walletTransactions/admin/withdraw-requests", {
      params: { page, limit, status },
    });
    return response;
  } catch (error) {
    console.error("Error fetching admin withdraw requests:", error);
    throw error;
  }
};

export const approveWithdrawRequest = async (id, walletTransactionId) => {
  try {
    const response = await axios.post(`/walletTransactions/admin/${id}/approve`, {
      walletTransactionId,
    });
    return response?.status;
  } catch (error) {
    console.error("Error approving withdrawal request:", error);
    throw error;
  }
};

export const rejectWithdrawRequest = async (id) => {
  try {
    const response = await axios.post(`/walletTransactions/admin/${id}/reject`);
    return response?.status;
  } catch (error) {
    console.error("Error rejecting withdrawal request:", error);
    throw error;
  }
};

export const getUserAssetCategory = async () => {
  try {
    const response = await axios.get("coins/category");
    return response;
  } catch (error) {
    console.error("Error fetching wallet transactions:", error);
    throw error;
  }
};

export const getWalletTransactionsSummary = async () => {
  try {
    const response = await axios.get("/walletTransactions/summary");
    return response?.data;
  } catch (error) {
    console.error("Error fetching wallet transactions summary:", error);
    throw error;
  }
};

export const getEarnings = async () => {
  try {
    const response = await axios.get("/transactions/earnings");
    return response?.data;
  } catch (error) {
    console.error("Error fetching wallet transactions summary:", error);
    throw error;
  }
};
